import { sendRealityCheckNotification } from './server';
import { SINGLETON_MODE } from 'js/components/common/PopupManager/constants';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const realityCheckPopupAction = ({ content, actionId }) => {
    publicEventsAPIService.trigger('realityPopup:shown');

    return showCommonPopupAction({
        id: actionId,
        singletonMode: SINGLETON_MODE.UPDATE,
        content,
        className: 'reality-check-popup',
        onClose: () => {
            publicEventsAPIService.trigger('realityPopup:closed', 'accept');
            sendRealityCheckNotification(actionId, 'reset');
        }
    });
};
